import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import EnterpriseIcon, { DragIcon, PinFilledIcon, PinIcon } from '@enterprise-ui/icons';
import React__default, { useCallback } from 'react';
import Button from '../../../../Button.js';
import Grid from '../../../../Grid.js';
import Input from '../../../../Input/index.js';
import { useColumnManager } from '../context/ColumnManagerContext.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var checkColumn = function checkColumn(columns, id, checked) {
  return columns.map(function (c) {
    return _objectSpread(_objectSpread({}, c), {}, {
      isVisible: c.field === id ? checked : c.isVisible
    });
  });
};
var pinColumnReducer = function pinColumnReducer(columns, id, pinned) {
  return columns.map(function (c) {
    return _objectSpread(_objectSpread({}, c), {}, {
      pinned: c.field === id ? pinned : c.pinned
    });
  });
};
var DefaultColumn = function DefaultColumn(_ref) {
  var dataTestId = _ref.dataTestId,
    innerRef = _ref.innerRef,
    data = _ref.data,
    allowPinning = _ref.allowPinning,
    dragHandle = _ref.dragHandle,
    draggableProps = _ref.draggableProps;
  var _useColumnManager = useColumnManager(),
    updateColumnDefs = _useColumnManager.updateColumnDefs;
  var isVisible = data.isVisible,
    headerName = data.headerName,
    pinned = data.pinned;
  var handleSelect = useCallback(function () {
    updateColumnDefs(function (prev) {
      return checkColumn(prev, data.field, !data.isVisible);
    });
  }, [data, updateColumnDefs]);
  var handlePin = useCallback(function () {
    updateColumnDefs(function (prev) {
      return pinColumnReducer(prev, data.field, !data.pinned);
    });
  }, [data, updateColumnDefs]);
  var pinLabel = pinned ? 'Unpin' : 'Pin';
  return /*#__PURE__*/React__default.createElement(Grid.Container, _extends({
    spacing: "none",
    align: "center",
    noWrap: true,
    ref: innerRef
  }, draggableProps), /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    "data-testid": "".concat(dataTestId, "_checkbox"),
    checked: isVisible,
    onChange: handleSelect,
    "aria-label": "".concat(isVisible ? 'hide' : 'show', " ").concat(data.headerName, " column")
  })), /*#__PURE__*/React__default.createElement(Grid.Item, _extends({}, dragHandle, {
    "aria-label": "drag ".concat(headerName, " column"),
    className: "C-ColumnManager__Column__Description",
    xs: true
  }), /*#__PURE__*/React__default.createElement(Grid.Container, {
    align: "center",
    spacing: "dense"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: DragIcon,
    className: "C-ColumnManager__Column__Description__DragHandle"
  })), /*#__PURE__*/React__default.createElement(Grid.Item, {
    xs: true
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "C-ColumnManager__Column__DescriptionText"
  }, headerName)))), allowPinning && /*#__PURE__*/React__default.createElement(Grid.Item, null, /*#__PURE__*/React__default.createElement(Button, {
    type: "ghost",
    "aria-label": "".concat(pinLabel, " ").concat(headerName, " column"),
    onClick: handlePin,
    iconOnly: true
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: pinned ? PinFilledIcon : PinIcon
  }))));
};

export { DefaultColumn as default };
